import { connect } from "react-redux";
import { IObjectUpdate } from "src/rematch/interfaces/IObjectUpdate";
import { Dispatch, iRootState } from "src/rematch/store";
import { withTranslation } from "react-i18next";
import IMfilesValueListItem from "src/backend/interfaces/mfiles/IMfilesValueListItem";
import { IItemFormProps, IItemFormState, ItemFormCommon } from "./ItemFormCommon";
import { PropertyDataType } from "src/backend/constants/datatypes";

class EditItemFormBase extends ItemFormCommon  {

  constructor(props: IItemFormProps) {
    super(props);
    this.state = {
      ...this.getInitialState(),
    }
  }

  title(): string {
    const { t } = this.props;
    return t("editor.modify");
  }

  getInitialState(): IItemFormState {
    const item = this.props.getItem(this.props.selectedItem);
    const properties = this.getInitialProperties(item, false);
    return {
      item: item,
      properties: properties,
    }
  }

  saveForm = (): void => {
    if(this.props.selectedItem === null) {
      return;
    }
    const item = this.props.getItem(this.props.selectedItem);
    const update: IObjectUpdate = {
      id: item.id,
      objectType: item.objectType,
      objectId: item.objectId,
      objectVersion: item.objectVersion,
      mfPropertyUpdates: [],
      ownPropertyUpdates: [],
    };
    for(const property of this.state.properties) {
      if(property.hasError) {
        return;
      }
      let propertyChanged = property.changed;
      if(!propertyChanged) {
        if(property.isOwnProperty) {
          const ownProperty = property.propertyIdOrName as string;
          if(ownProperty === "start" || ownProperty === "end") {
            //Always change dates since they may have changed when data was loaded 
            propertyChanged = true;
          }
        }
      }
      if(propertyChanged) {
        if(property.isOwnProperty) {
          const ownProperty = property.propertyIdOrName as string;
          const objectTypeConfig = this.props.objectTypeConfigurations.get(item.objectType);
          if(ownProperty === "start") {
            if(objectTypeConfig.dateProperties?.length === 2) {
              update.mfPropertyUpdates.push({
                propertyId: objectTypeConfig.dateProperties[0],
                dataType: PropertyDataType.Date,
                oldValue: property.originalValue,
                newValue: property.value === "" ? null : property.value,
              });
            }
            if(objectTypeConfig.timeProperties?.length === 2) {
              update.mfPropertyUpdates.push({
                propertyId: objectTypeConfig.timeProperties[0],
                dataType: PropertyDataType.Time,
                oldValue: property.originalValue,
                newValue: property.value === "" ? null : property.value,
              });
            }
          }
          if(ownProperty === "end") {
            if(objectTypeConfig.dateProperties?.length === 2) {
              update.mfPropertyUpdates.push({
                propertyId: objectTypeConfig.dateProperties[1],
                dataType: PropertyDataType.Date,
                oldValue: property.originalValue,
                newValue: property.value === "" ? null : property.value,
              });
            }
            if(objectTypeConfig.timeProperties?.length === 2) {
              update.mfPropertyUpdates.push({
                propertyId: objectTypeConfig.timeProperties[1],
                dataType: PropertyDataType.Time,
                oldValue: property.originalValue,
                newValue: property.value === "" ? null : property.value,
              });
            }
          }
        } else {
          update.mfPropertyUpdates.push({
            propertyId: property.propertyIdOrName as number,
            dataType: property.dataType,
            oldValue: property.originalValue,
            newValue: property.value,
          });
        }
      }
    }
    if(update.mfPropertyUpdates.length > 0 || update.ownPropertyUpdates.length > 0) {
      this.props.updateManyAsync([update]);
    }
    this.props.toggleShowForm();
  }
  
}

export const EditItemForm = withTranslation()(connect(
  (state: iRootState) => ({
    httpClient: state.common.httpClient,
    selectedItem: state.items.selectedItem,
    getItem: (itemId: number) => state.items.allData[itemId],
    
    getEditProperties: (objectType: number) => state.common.configuration.objectTypeConfigurations.get(objectType)?.editConfig?.editProperties ?? [],
    getPropertyDefinition: (propertyId: number) => state.common.configuration.propertyDefinitions.get(propertyId),
    getValueListDefinition: (valueListId: number) => state.common.configuration.valueListDefinitions.get(valueListId),
    getValueListItems: (valueListId: number) => state.common.configuration.valueListItems[valueListId],
    getWorkflow: (workflowId: number) =>  state.common.configuration.workflows.get(workflowId),
    getClass: (classId: number) => state.common.configuration.classes.get(classId),
    objectTypeConfigurations: state.common.configuration.objectTypeConfigurations,
    dragndropConfigurations: state.common.configuration.dragndropConfigurations,
    valueListItems: state.common.configuration.valueListItems,
    dateFormat: state.UI.displaySettings.dateFormat,
    timeFormat: state.UI.displaySettings.timeFormat,
    showTimeInTable: state.UI.displaySettings.showTimeInTable,
  }), 
  (dispatch: Dispatch) => ({
    toggleShowForm: dispatch.UI.toggleShowEditBox,
    updateManyAsync: dispatch.items.updateManyAsync,
    insertItemAsync: dispatch.items.insertItemAsync,
    setValueListItems: (valueListId: number, valueListItems: IMfilesValueListItem[]) => dispatch.common.setValueListItems(valueListId, valueListItems),
  })
)(EditItemFormBase));
